import { render } from "./Square.vue?vue&type=template&id=2f9b1fd4&ts=true"
import script from "./Square.vue?vue&type=script&lang=ts"
export * from "./Square.vue?vue&type=script&lang=ts"

import "./Square.vue?vue&type=style&index=0&id=2f9b1fd4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__